import { useEffect, useState } from 'react';
import { BoardConfiguration } from '../models/boardConfiguration';
import { createBoardConfigurations } from '../utils/boardConfigurationFactory';
import { logError } from '../utils/errorLogging';
import useQueryParameters from './useQueryParameters';

export default function useBoardConfigurations() {
  const [error, setError] = useState<string | undefined>();
  const [boardConfigurations, setBoardConfigurations] = useState<
    BoardConfiguration[] | undefined
  >();
  const queryParameters = useQueryParameters();

  useEffect(() => {
    try {
      const boardConfigurations = createBoardConfigurations(queryParameters);
      setBoardConfigurations(boardConfigurations);
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message);
      }
      logError(error);
    }
  }, [queryParameters]);

  return { boardConfigurations, error };
}
